import { createSelector } from 'reselect'
import { selectCannedReplyTemplatesTotalCountOrNull } from './selectCannedReplyTemplatesTotalCountOrNull'

export const selectCannedReplyTemplatesTotalCount = createSelector(
  selectCannedReplyTemplatesTotalCountOrNull,
  totalCount => totalCount
)
